var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bakatpil"},[_c('div',{staticClass:"huvud"},[_c('div',{staticClass:"del1"}),_c('div',{staticClass:"del2"})]),_c('div',{staticClass:"del3"}),_c('div',{staticClass:"del4"})])
}]

export { render, staticRenderFns }